(() => {
  class CookieBoxBuilder extends HTMLElement {
    constructor() {
      super();
      this.state = {
        size: 12,
        variantId: null,
        priceCents: 0,
        mode: 'mix',
        mix: null,
        counts: {},
        customCounts: {},
      };
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.sizeButtons = [...this.querySelectorAll('[data-cc-size]')];
      this.modeButtons = [...this.querySelectorAll('[data-cc-mode]')];
      this.mixButtons = [...this.querySelectorAll('[data-cc-mix]')];
      this.cookieCards = [...this.querySelectorAll('[data-cc-cookie]')];
      this.addButton = this.querySelector('[data-cc-add]');
      this.progressBar = this.querySelector('[data-cc-progress-bar]');
      this.progressText = this.querySelector('[data-cc-progress-text]');
      this.remainingText = this.querySelector('[data-cc-remaining]');
      this.summaryTitle = this.querySelector('[data-cc-summary-title]');
      this.summaryText = this.querySelector('[data-cc-summary-text]');
      this.mixPanel = this.querySelector('[data-cc-panel="mix"]');
      this.customPanel = this.querySelector('[data-cc-panel="custom"]');
      this.upsell6 = this.querySelector('[data-cc-upsell="6-12"]');
      this.upsell12 = this.querySelector('[data-cc-upsell="12-24"]');
      this.errorEl = this.querySelector('[data-cc-error]');
      this.successEl = this.querySelector('[data-cc-success]');
      this.giftToggle = this.querySelector('[data-cc-gift-toggle]');
      this.giftFields = this.querySelector('[data-cc-gift-fields]');
      this.giftMessage = this.querySelector('[data-cc-gift-message]');
      this.giftVariantId = Number(this.dataset.giftVariantId || 0);
      this.giftToggle?.addEventListener('change', () => {
        if (this.giftFields) this.giftFields.hidden = !this.giftToggle.checked;
        this.clearMessages();
        this.render();
      });


      this.cookieCards.forEach((card) => {
        const key = card.dataset.key;
        this.state.counts[key] = 0;
        this.state.customCounts[key] = 0;
        card.querySelector('[data-cc-plus]')?.addEventListener('click', () => this.changeQty(key, 1));
        card.querySelector('[data-cc-minus]')?.addEventListener('click', () => this.changeQty(key, -1));
        card.querySelector('[data-cc-image-add]')?.addEventListener('click', () => this.changeQty(key, 1));
        card.querySelector('[data-cc-info-open]')?.addEventListener('click', (event) => this.openCookieInfo(card, event.currentTarget));
      });

      this.infoDialog = this.querySelector('[data-cc-info-dialog]');
      this.infoBody = this.querySelector('[data-cc-info-body]');
      this.infoOpener = null;
      this.querySelector('[data-cc-info-close]')?.addEventListener('click', () => this.infoDialog?.close());
      this.infoDialog?.addEventListener('click', (event) => {
        if (event.target === this.infoDialog) this.infoDialog.close();
      });
      this.infoDialog?.addEventListener('close', () => this.infoOpener?.focus());
      this.querySelectorAll('[data-cc-mix-info]').forEach((button) => {
        button.addEventListener('click', () => this.openMixInfo(button.dataset.ccMixInfo, button));
      });

      this.sizeButtons.forEach((btn) => btn.addEventListener('click', () => this.selectSize(btn)));
      this.modeButtons.forEach((btn) => btn.addEventListener('click', () => this.selectMode(btn.dataset.ccMode)));
      this.mixButtons.forEach((btn) => btn.addEventListener('click', () => this.applyMix(btn.dataset.ccMix)));
      this.querySelector('[data-cc-equalize]')?.addEventListener('click', () => this.equalizeCustom());
      this.clearButton = this.querySelector('[data-cc-clear]');
      this.clearButton?.addEventListener('click', () => this.clearCustom());
      this.querySelector('[data-cc-upgrade="12"]')?.addEventListener('click', () => this.upgradeTo(12));
      this.querySelector('[data-cc-upgrade="24"]')?.addEventListener('click', () => this.upgradeTo(24));
      this.addButton?.addEventListener('click', () => this.addToCart());
      this.querySelector('[data-cc-repeat]')?.addEventListener('click', () => this.prepareNextBox());

      const requestedSize = Number(new URLSearchParams(window.location.search).get('box') || 0);
      const requestedButton = [6, 12, 24].includes(requestedSize)
        ? this.querySelector(`[data-cc-size="${requestedSize}"]`)
        : null;
      const defaultSize = requestedButton || this.querySelector('[data-cc-size][aria-pressed="true"]') || this.sizeButtons[0];
      if (defaultSize) this.selectSize(defaultSize, { preserve: true, scroll: false });
      this.selectMode('mix', false);
      if (this.giftToggle && new URLSearchParams(window.location.search).get('gift') === '1') {
        this.giftToggle.checked = true;
        if (this.giftFields) this.giftFields.hidden = false;
      }
      this.render();
    }

    openInfo(opener, renderContent) {
      if (!this.infoDialog || !this.infoBody) return;
      this.infoOpener = opener;
      this.infoBody.replaceChildren();
      renderContent(this.infoBody);
      if (typeof this.infoDialog.showModal === 'function') this.infoDialog.showModal();
      else this.infoDialog.setAttribute('open', '');
      this.infoDialog.querySelector('[data-cc-info-close]')?.focus();
    }

    openCookieInfo(card, opener) {
      const template = card.querySelector('[data-cc-info-template]');
      if (!template) return;
      this.openInfo(opener, (body) => body.append(template.content.cloneNode(true)));
    }

    openMixInfo(type, opener) {
      const cards = type === 'chocolate'
        ? this.cookieCards.filter((card) => card.dataset.chocolate === 'true')
        : this.cookieCards;
      this.openInfo(opener, (body) => {
        const heading = document.createElement('h3');
        heading.className = 'cc-cookie-info-content__name';
        heading.textContent = type === 'chocolate' ? 'ALL CHOCOLATE' : 'ALL SIX';
        body.append(heading);
        const intro = document.createElement('p');
        intro.className = 'cc-cookie-info-content__subline';
        intro.textContent = 'Enthaltene Sorten und ihre Produktinformationen:';
        body.append(intro);
        cards.forEach((card) => {
          const details = document.createElement('details');
          details.className = 'cc-cookie-info-content__mix-item';
          const summary = document.createElement('summary');
          summary.textContent = card.dataset.name || 'Cookie';
          details.append(summary);
          const template = card.querySelector('[data-cc-info-template]');
          if (template) details.append(template.content.cloneNode(true));
          body.append(details);
        });
      });
    }

    get total() {
      return Object.values(this.state.counts).reduce((sum, n) => sum + Number(n || 0), 0);
    }

    get target() { return Number(this.state.size || 0); }

    selectSize(btn, options = {}) {
      const newSize = Number(btn.dataset.ccSize);
      const preserve = options.preserve !== false;
      // V20: Boxgroesse jederzeit wechseln.
      // Im CUSTOM-Modus bleibt jede gewaehlte Sorte unveraendert;
      // bei einem aktiven Mix wird die Zusammensetzung gleichmaessig neu verteilt.

      this.clearMessages();
      this.state.size = newSize;
      this.state.variantId = Number(btn.dataset.variantId || 0);
      this.state.priceCents = Number(btn.dataset.priceCents || 0);

      this.sizeButtons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));

      if (!preserve) {
        this.resetCounts();
      } else if (this.state.mode === 'mix' && this.state.mix) {
        this.applyMix(this.state.mix, false);
      }

      this.render();
      if (options.scroll !== false) this.querySelector('[data-cc-stage]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    selectMode(mode, render = true) {
      this.state.mode = mode;
      this.modeButtons.forEach((b) => b.setAttribute('aria-selected', b.dataset.ccMode === mode ? 'true' : 'false'));
      this.mixPanel.hidden = mode !== 'mix';
      this.customPanel.hidden = mode !== 'custom';

      if (mode === 'custom') {
        this.state.counts = { ...this.state.customCounts };
        this.state.mix = null;
        this.mixButtons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      } else if (this.state.mix) {
        this.applyMix(this.state.mix, false);
      } else {
        this.resetCounts(false);
      }
      if (render) this.render();
    }

    resetCounts(render = true) {
      Object.keys(this.state.counts).forEach((key) => (this.state.counts[key] = 0));
      if (this.state.mode === 'custom') this.state.customCounts = { ...this.state.counts };
      if (render) this.render();
    }

    changeQty(key, delta) {
      if (this.state.mode !== 'custom') return;
      const next = Math.max(0, Number(this.state.counts[key] || 0) + delta);
      const nextTotal = this.total + delta;
      if (delta > 0 && nextTotal > this.target) return;
      this.state.counts[key] = next;
      this.state.customCounts[key] = next;
      this.clearMessages();
      this.render();
    }

    equalizeCustom() {
      this.selectMode('custom', false);
      const keys = this.cookieCards.map((c) => c.dataset.key);
      if (!keys.length) return;
      const base = Math.floor(this.target / keys.length);
      let remainder = this.target % keys.length;
      keys.forEach((key) => {
        const value = base + (remainder-- > 0 ? 1 : 0);
        this.state.counts[key] = value;
        this.state.customCounts[key] = value;
      });
      this.render();
    }

    clearCustom() {
      this.selectMode('custom', false);
      Object.keys(this.state.counts).forEach((key) => {
        this.state.counts[key] = 0;
        this.state.customCounts[key] = 0;
      });
      this.clearMessages();
      this.render();
    }

    prepareNextBox() {
      Object.keys(this.state.counts).forEach((key) => {
        this.state.counts[key] = 0;
        this.state.customCounts[key] = 0;
      });
      this.state.mix = null;
      if (this.giftToggle) this.giftToggle.checked = false;
      if (this.giftMessage) this.giftMessage.value = '';
      if (this.giftFields) this.giftFields.hidden = true;
      this.mixButtons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      this.selectMode('mix', false);
      this.clearMessages();
      this.render();
      this.querySelector('[data-cc-stage]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    applyMix(type, render = true) {
      this.state.mode = 'mix';
      this.state.mix = type;
      this.modeButtons.forEach((b) => b.setAttribute('aria-selected', b.dataset.ccMode === 'mix' ? 'true' : 'false'));
      this.mixPanel.hidden = false;
      this.customPanel.hidden = true;
      this.mixButtons.forEach((b) => b.setAttribute('aria-pressed', b.dataset.ccMix === type ? 'true' : 'false'));

      Object.keys(this.state.counts).forEach((key) => (this.state.counts[key] = 0));
      let cards = type === 'chocolate'
        ? this.cookieCards.filter((c) => c.dataset.chocolate === 'true')
        : this.cookieCards;
      if (!cards.length) {
        this.showError(type === 'chocolate' ? 'Markiere im Theme-Editor mindestens einen Cookie für ALL CHOCOLATE.' : 'Füge Cookie-Blöcke hinzu.');
        return;
      }
      const base = Math.floor(this.target / cards.length);
      let remainder = this.target % cards.length;
      cards.forEach((card) => {
        const key = card.dataset.key;
        this.state.counts[key] = base + (remainder-- > 0 ? 1 : 0);
      });
      this.clearMessages();
      if (render) this.render();
    }

    upgradeTo(size) {
      const btn = this.sizeButtons.find((b) => Number(b.dataset.ccSize) === size);
      if (!btn) return;
      const wasMix = this.state.mode === 'mix' && this.state.mix;
      this.selectSize(btn, { preserve: true, scroll: false });
      if (wasMix) this.applyMix(this.state.mix, false);
      this.render();
      this.querySelector('[data-cc-stage]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    render() {
      const total = this.total;
      const target = this.target;
      const remaining = Math.max(0, target - total);
      const tooMany = Math.max(0, total - target);
      const overfilled = tooMany > 0;
      const complete = target > 0 && total === target;
      const percentage = target ? Math.min(100, (total / target) * 100) : 0;

      if (this.progressBar) {
        this.progressBar.style.width = `${percentage}%`;
        const track = this.progressBar.parentElement;
        if (track) {
          track.setAttribute('role', 'progressbar');
          track.setAttribute('aria-valuemin', '0');
          track.setAttribute('aria-valuemax', String(target));
          // aria-valuenow darf bei progressbar nicht ueber aria-valuemax liegen.
          track.setAttribute('aria-valuenow', String(Math.min(total, target)));
          track.setAttribute('aria-valuetext', overfilled
            ? `${total} von ${target} Cookies gewählt, ${tooMany} zu viel`
            : `${total} von ${target} Cookies gewählt`);
          track.setAttribute('aria-label', `${total} von ${target} Cookies gewählt`);
        }
      }
      if (this.progressText) this.progressText.textContent = `${total} von ${target} Cookies gewählt`;
      if (this.remainingText) this.remainingText.textContent = overfilled
        ? `${tooMany} ${tooMany === 1 ? 'Cookie' : 'Cookies'} zu viel`
        : (complete ? 'Deine Box ist komplett.' : `Noch ${remaining} ${remaining === 1 ? 'Cookie' : 'Cookies'}`);

      // V20: Freundliche Hilfestellung, ohne die individuelle Auswahl zu veraendern.
      this.toggleAttribute('data-cc-overfilled', overfilled);
      const overfillHint = this.querySelector('[data-cc-overfill-hint]');
      if (overfillHint) {
        overfillHint.hidden = !overfilled;
        if (overfilled) {
          overfillHint.textContent = `Du hast ${tooMany} ${tooMany === 1 ? 'Cookie' : 'Cookies'} zu viel ausgewählt. Welche Cookies möchtest du behalten? Entferne sie mit − oder wechsle zurück zur größeren Box.`;
        }
      }

      this.cookieCards.forEach((card) => {
        const key = card.dataset.key;
        const count = Number(this.state.counts[key] || 0);
        const output = card.querySelector('[data-cc-qty]');
        if (output) output.textContent = count;
        const minus = card.querySelector('[data-cc-minus]');
        const plus = card.querySelector('[data-cc-plus]');
        if (minus) minus.disabled = count <= 0;
        if (plus) plus.disabled = total >= target;
        const imageAdd = card.querySelector('[data-cc-image-add]');
        if (imageAdd) imageAdd.disabled = total >= target;
      });

      const giftPrice = this.giftToggle?.checked ? 100 : 0;
      const price = this.formatMoney(this.state.priceCents + giftPrice);
      if (this.summaryTitle) this.summaryTitle.textContent = overfilled
        ? `${total} von ${target} – bitte ${tooMany} entfernen`
        : (complete ? `${target} von ${target} – deine Box ist fertig.` : `${total} / ${target} Cookies`);
      if (this.summaryText) this.summaryText.textContent = overfilled
        ? `${tooMany} ${tooMany === 1 ? 'Cookie' : 'Cookies'} zu viel`
        : (complete ? `${target}er Box · ${price}` : `Noch ${remaining} auswählen · ${price}`);
      if (this.addButton) {
        this.addButton.disabled = !complete || !this.state.variantId;
        this.addButton.textContent = overfilled
          ? `NOCH ${tooMany} ENTFERNEN`
          : (complete ? `BOX HINZUFÜGEN · ${price}` : `NOCH ${remaining} AUSWÄHLEN`);
      }

      if (this.upsell6) this.upsell6.hidden = !(complete && target === 6);
      if (this.upsell12) this.upsell12.hidden = !(complete && target === 12);
      if (this.clearButton) this.clearButton.disabled = total === 0;
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')} €`;
      }
    }

    composition() {
      return this.cookieCards
        .map((card) => ({
          key: card.dataset.key,
          name: card.dataset.name,
          variantId: Number(card.dataset.variantId || 0),
          sku: card.dataset.sku || '',
          quantity: Number(this.state.counts[card.dataset.key] || 0),
        }))
        .filter((x) => x.quantity > 0);
    }

    async addToCart() {
      if (this.total !== this.target || !this.state.variantId || !this.addButton) return;
      this.clearMessages();
      this.addButton.disabled = true;
      this.addButton.classList.add('is-loading');
      const originalLabel = this.addButton.textContent;
      this.addButton.textContent = 'WIRD HINZUGEFÜGT …';

      const wantsGift = !!this.giftToggle?.checked;
      const giftText = (this.giftMessage?.value || '').trim();
      if (wantsGift && (!this.giftVariantId || Number(this.dataset.giftPriceCents) !== 100)) {
        this.showError('Die Grußkarte ist noch nicht eingerichtet. Bitte versuche es später erneut.');
        this.addButton.classList.remove('is-loading');
        this.render();
        return;
      }
      if (wantsGift && (!giftText || giftText.length > 220)) {
        this.showError('Bitte gib eine persönliche Nachricht mit maximal 220 Zeichen ein.');
        this.giftMessage?.focus();
        this.addButton.classList.remove('is-loading');
        this.render();
        return;
      }
      const components = this.composition();
      const visibleSummary = components.map((x) => `${x.name} × ${x.quantity}`).join(', ');
      const properties = {
        'Deine Auswahl': visibleSummary,
        '_cc_box_size': String(this.target),
        '_cc_mode': this.state.mode === 'mix' ? (this.state.mix === 'all' ? 'ALL SIX' : 'ALL CHOCOLATE') : 'CUSTOM',
        '_cc_components': JSON.stringify(components),
      };

      const items = [{ id: this.state.variantId, quantity: 1, properties }];
      if (wantsGift) {
        const boxRef = `cc-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
        properties['Grußkarte'] = 'Ja (+1,00 €)';
        properties['Grußkartentext'] = giftText;
        properties['_cc_box_ref'] = boxRef;
        items.push({
          id: this.giftVariantId, quantity: 1,
          properties: { 'Grußkarte für': `${this.target}er Cookie Box`, 'Nachricht': giftText, '_cc_box_ref': boxRef },
        });
      }

      // The bare /cart/add URL can return an HTML page. Shopify's documented
      // Ajax endpoint is /cart/add.js; explicitly request JSON.
      // Do not request dynamic cart sections until the basic add-to-cart flow
      // has been verified. Redirect to the real cart after a successful add.
      const root = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const cartAddUrl = `${root}cart/add.js`;
      const cartUrl = window.routes?.cart_url || `${root}cart`;
      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items }),
        });
        const responseText = await response.text();
        let data;
        try {
          data = JSON.parse(responseText);
        } catch (_) {
          throw new Error(`Shopify hat keine Warenkorb-Daten geliefert (HTTP ${response.status}). Prüfe zuerst den Warenkorb, bevor du erneut klickst. Falls er leer ist: Box-Variante, Verkaufskanal und Shop-Zugriff prüfen.`);
        }
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || `Die Box konnte nicht hinzugefügt werden (HTTP ${response.status}).`);
        }
        window.location.assign(cartUrl);
        return;
      } catch (err) {
        this.showError(err.message || 'Etwas ist schiefgelaufen. Bitte versuche es erneut.');
      } finally {
        this.addButton.classList.remove('is-loading');
        this.addButton.disabled = this.total !== this.target;
        this.addButton.textContent = originalLabel;
        this.render();
      }
    }

    clearMessages() {
      if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
      if (this.successEl) { this.successEl.hidden = true; this.successEl.textContent = ''; }
    }
    showError(message) { if (this.errorEl) { this.errorEl.textContent = message; this.errorEl.hidden = false; } }
    showSuccess(message) {
      if (!this.successEl) return;
      const text = this.successEl.querySelector('[data-cc-success-text]');
      if (text) text.textContent = message;
      this.successEl.hidden = false;
    }
  }

  if (!customElements.get('cookie-box-builder')) customElements.define('cookie-box-builder', CookieBoxBuilder);
})();
